
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 37","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#111","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M34.51 26.564A13.848 13.848 0 0039 16.545C39 7.995 30.536 1 20 1S1 7.995 1 16.545s8.464 15.546 19 15.546c1.8-.026 3.594-.228 5.355-.605l10.19 4.06-1.036-8.982zM11.364 13.091h17.272M11.364 20h10.363"}})])])
          )
        }
      }
    